import { jsx as _jsx } from "react/jsx-runtime";
import { KevelBanners } from '../../Shared/KevelBanners/KevelBanners.js';
export const MobileSecondaryKevelBanners = ({ kevelAds }) => {
    return (_jsx(KevelBanners, { kevelAds: kevelAds, ga4SubFeature: "secondary_location", variation: "mobile", imageSizes: "(min-width: 420px) calc(66.76vw - 34px), calc(83vw - 30px)" }));
};
//# sourceMappingURL=MobileSecondaryKevelBanners.js.map